<template>
	<!-- servizi per le immagini (Impostazioni > Immagini): stesso schema delle righe di Ai / Social -->
	<v-card width="100%" outlined elevation-0 class="mt-4" data-tour="services">
		<v-toolbar flat dense class="border_bottom" shaped>
			<v-toolbar-title class="subtitle-1">Servizi</v-toolbar-title>
		</v-toolbar>
		<div class="sp-muted px-4 pt-3">Si attiva un servizio alla volta: è quello che usa lo studio immagini della scheda prodotto. Accendendone uno, l'altro si spegne.</div>
		<v-data-table :headers="headers" class="elevation-0 cellanowrap" :hide-default-header="mobileCards" :class="{ 'table-cards': mobileCards }" hide-default-footer disable-pagination disable-sort>
			<template #body>
				<!-- telefono: ogni servizio diventa una card -->
				<tbody v-if="mobileCards" class="is-cards">
					<tr v-for="s in servizi" :key="s.key">
						<td :colspan="headers.length" class="px-3 py-1">
							<key-value-card>
								<template v-slot:title>
									<div class="d-flex align-center">
										<v-avatar size="32px" tile class="mr-2"><img :src="s.logo" :alt="s.nome" /></v-avatar>
										{{ s.nome }}
									</div>
								</template>
								<template v-slot:actions>
									<v-switch v-model="modello(s).active" color="primary" class="mt-0 pt-0 mr-2" hide-details @change="cambiaAttivo(s)" />
									<v-btn small icon color="primary" :title="aperto(s) ? 'Chiudi' : 'Impostazioni'" @click="apri(s)">
										<v-icon>{{ aperto(s) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
									</v-btn>
								</template>
								<div class="sp-muted mb-2">{{ riepilogo(s) }}</div>
								<service-panel v-if="aperto(s)" :servizio="s" :modello="modello(s)" :intestazione="false" @save="salva(s)">
									<div class="is-hint mb-3" v-html="s.istruzioni"></div>
									<template v-slot:azioni>
										<v-btn small outlined color="primary" @click="verifica(s)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
										<v-spacer></v-spacer>
									</template>
								</service-panel>
							</key-value-card>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<template v-for="s in servizi">
						<tr :key="s.key" class="as-list-row" :class="{ 'as-list-row--open': aperto(s) }" @click="apri(s)">
							<td class="pr-0" style="width: 40px">
								<v-btn small icon data-tour="services-expand" :title="aperto(s) ? 'Chiudi' : 'Impostazioni'" @click.stop="apri(s)">
									<v-icon>{{ aperto(s) ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
								</v-btn>
							</td>
							<td>
								<v-avatar size="32px" tile><img :src="s.logo" :alt="s.nome" /></v-avatar>
								{{ s.nome }}
							</td>
							<td class="sp-muted">{{ riepilogo(s) }}</td>
							<td @click.stop>
								<v-switch v-model="modello(s).active" color="primary" class="mt-0" hide-details @change="cambiaAttivo(s)" />
							</td>
						</tr>
						<tr v-if="aperto(s)" :key="s.key + '-panel'" class="as-expanded">
							<td :colspan="headers.length" class="py-3">
								<service-panel :servizio="s" :modello="modello(s)" data-tour="services-settings" @save="salva(s)">
									<div class="is-hint mb-3" v-html="s.istruzioni"></div>
									<template v-slot:azioni>
										<v-btn small outlined color="primary" @click="verifica(s)"><v-icon left small>mdi-connection</v-icon>Verifica connessione</v-btn>
										<v-spacer></v-spacer>
									</template>
								</service-panel>
							</td>
						</tr>
					</template>
				</tbody>
			</template>
		</v-data-table>

		<marketplace-connection-check v-model="connectionCheck.open" :service="connectionCheck.service" :draft="connectionDraft"></marketplace-connection-check>
		<v-snackbar v-model="snackbar.open" :color="snackbar.color" multi-line :timeout="5000">
			{{ snackbar.text }}
			<v-btn dark text @click="snackbar.open = false">Chiudi</v-btn>
		</v-snackbar>
	</v-card>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import ServicePanel from './ServicePanel.vue';
import MarketplaceConnectionCheck from './MarketplaceConnectionCheck.vue';

/*
 * Servizi che lavorano sulle immagini dei prodotti: Photoroom e Claid. Le chiavi servono allo studio
 * immagini della scheda prodotto (Migliora immagine), che con entrambi attivi fa scegliere quale usare.
 * Salvataggio e verifica come in Ai / Social.
 */
export default {
	name: 'ImageServices',
	components: { KeyValueCard, ServicePanel, MarketplaceConnectionCheck },
	data() {
		return {
			headers: [{ text: '' }, { text: 'Servizio' }, { text: 'Stato' }, { text: 'Attivo' }],
			aperti: [],
			connectionCheck: { open: false, service: 'photoroom' },
			snackbar: { open: false, color: '', text: '' },
			// stato dei servizi letto dal backend (immagini disponibili di Photoroom), per servizio
			stati: {},
			photoroom: { active: false, setting: { apiKey: '', sandbox: true }, type: 'ai', service: 'photoroom' },
			claid: { active: false, setting: { apiKey: '' }, type: 'ai', service: 'claid' },
			servizi: [
				{
					key: 'photoroom',
					nome: 'Photoroom',
					logo: require('@/assets/images/ai/photoroom.png'),
					titoloSwitch: 'Modalità',
					istruzioni:
						'Crea la chiave nella <a href="https://app.photoroom.com/api-dashboard" target="_blank" rel="noopener">dashboard API di Photoroom</a> e incollala qui. ' +
						'In <b>sandbox</b> le elaborazioni sono gratuite (1.000 al mese) ma le immagini escono con il watermark: serve per provare. ' +
						'Spenta la sandbox, ogni immagine elaborata scala un credito del tuo piano Photoroom.',
					campi: [
						{ key: 'apiKey', label: 'Chiave API', tipo: 'password', pieno: true },
						{ key: 'sandbox', label: 'Sandbox (gratuita, con watermark)', tipo: 'switch' },
					],
				},
				{
					key: 'claid',
					nome: 'Claid',
					logo: require('@/assets/images/ai/claid.png'),
					istruzioni:
						'Crea la chiave nella <a href="https://claid.ai/account/api" target="_blank" rel="noopener">pagina API keys di Claid</a>, con il permesso <b>Image editing</b>, e incollala qui. ' +
						'Claid non ha una sandbox: ogni elaborazione consuma crediti del tuo piano (alla registrazione ne regala alcuni per provare). ' +
						'I crediti residui si vedono nella dashboard di Claid.',
					campi: [{ key: 'apiKey', label: 'Chiave API', tipo: 'password', pieno: true }],
				},
			],
		};
	},
	computed: {
		...mapGetters({ getUrl: 'settings/getUrl', getToken: 'profile/getToken', getServices: 'services/getServices' }),
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		// la verifica controlla i dati del form, anche se non ancora salvati
		connectionDraft() {
			const modello = this[this.connectionCheck.service];
			return modello ? { setting: modello.setting, active: !!modello.active } : null;
		},
	},
	async created() {
		await this.fetchService(['photoroom', 'claid']);
		const salvati = this.getServices || [];
		const photoroom = salvati.find(s => s.service === 'photoroom');
		if (photoroom) {
			this.photoroom = {
				active: !!photoroom.active,
				setting: { apiKey: photoroom.setting?.apiKey || '', sandbox: photoroom.setting?.sandbox !== false },
				type: 'ai',
				service: 'photoroom',
			};
		}
		const claid = salvati.find(s => s.service === 'claid');
		if (claid) {
			this.claid = { active: !!claid.active, setting: { apiKey: claid.setting?.apiKey || '' }, type: 'ai', service: 'claid' };
		}
		this.caricaStati();
	},
	methods: {
		...mapMutations({ setPreload: 'settings/setPreload', setLogout: 'profile/setLogout' }),
		...mapActions({ fetchService: 'services/getServiceFetch', setService: 'services/updateData' }),
		modello(s) {
			return this[s.key];
		},
		aperto(s) {
			return this.aperti.includes(s.key);
		},
		apri(s) {
			this.aperti = this.aperto(s) ? this.aperti.filter(k => k !== s.key) : [...this.aperti, s.key];
		},
		verifica(s) {
			this.connectionCheck.service = s.key;
			this.connectionCheck.open = true;
		},
		riepilogo(s) {
			const m = this.modello(s);
			if (!m.active) return 'Disattivato';
			if (!m.setting.apiKey) return 'Manca la chiave API';
			// Claid non ha sandbox e non espone i crediti via API
			if (s.key === 'claid') return 'Attivo · crediti nella dashboard Claid';
			const modo = m.setting.sandbox ? 'Sandbox' : 'Produzione';
			const stato = this.stati[s.key];
			if (stato && stato.available && stato.credits !== null && stato.credits !== undefined) return `${modo} · ${stato.credits} immagini disponibili`;
			return modo;
		},
		// lo studio lavora con un solo servizio: accenderne uno spegne gli altri
		async cambiaAttivo(s) {
			if (this.modello(s).active) {
				for (const altro of this.servizi.filter(a => a.key !== s.key && this.modello(a).active)) {
					this.modello(altro).active = false;
					await this.salva(altro, { silenzioso: true });
				}
			}
			await this.salva(s);
		},
		async caricaStati() {
			const res = await this.$store.dispatch('imagestudio/status');
			this.stati = res || {};
		},
		// silenzioso: salvataggio di contorno (lo spegnimento dell'altro servizio), senza messaggio ne' ricarica
		async salva(s, { silenzioso = false } = {}) {
			this.setPreload(true);
			try {
				const { data } = await axios.post(`${this.getUrl}services/update`, this.modello(s), { headers: { Authorization: `Bearer ${this.getToken}` } });
				this.setService(data.data);
				if (silenzioso) return;
				const spento = this.servizi.find(a => a.key !== s.key && !this.modello(a).active && this.modello(s).active);
				this.snackbar = { open: true, color: 'success', text: spento ? `${s.nome} attivo: lo studio immagini ora usa ${s.nome}` : 'Operazione effettuata con successo' };
				this.caricaStati();
			} catch (err) {
				if (err.response && err.response.status === 401) {
					this.setLogout();
					this.$router.push('/login');
					return;
				}
				const errors = err.response && err.response.data && err.response.data.error;
				this.snackbar = { open: true, color: 'error', text: (errors && !Array.isArray(errors) && errors) || err.message };
			} finally {
				this.setPreload(false);
			}
		},
	},
};
</script>

<style scoped>
.sp-muted {
	color: #5f6b7a;
	font-size: 13px;
}
.is-hint {
	font-size: 13px;
	color: #5f6b7a;
	line-height: 1.5;
}
.as-list-row {
	cursor: pointer;
}
.as-list-row--open,
.as-list-row--open:hover {
	background: #f3f6fa !important;
}
.as-expanded,
.as-expanded:hover {
	background: transparent !important;
}
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.is-cards,
.is-cards tr {
	display: block;
	width: 100%;
}
.is-cards tr,
.is-cards tr:hover {
	background: transparent !important;
}
.is-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
</style>
